import { DriveFile } from '@/modules/drive/domain/models/DriveFile'

import { axios, Response } from '../index'

export default async function updateFileNameGroup(
  fileId: string,
  name: string
): Response<DriveFile> {
  return await axios.put(`/v1/group-files/${fileId}/rename`, { name })
}
